import type { Theme } from '@mui/material';

export const LEGEND_SWATCH_RADIUS = '1px';

export const ZOOM_CONTROLS_MARGIN = ({ tokens: { space } }: Theme) =>
  `${space.md} ${space.mdMinus} -${space.lg} auto`;
